export const isAndroid = (): boolean => {
  return window.navigator.userAgent.includes('Android');
};
